const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const LeagueAdd = () => import(/* webpackChunkName: "league" */ '@/modules/league/view/add.vue');
const LeagueEdit = () => import(/* webpackChunkName: "league" */ '@/modules/league/view/edit.vue');
const LeagueList = () => import(/* webpackChunkName: "league" */ '@/modules/league/view/index.vue');
const LeagueRewardAdd = () => import(/* webpackChunkName: "league" */ '@/modules/league/tier/reward/view/add.vue');
const LeagueRewardEdit = () => import(/* webpackChunkName: "league" */ '@/modules/league/tier/reward/view/edit.vue');
const LeagueRewardList = () => import(/* webpackChunkName: "league"*/ '@/modules/league/tier/reward/view/index.vue');
const LeagueTierAdd = () => import(/* webpackChunkName: "league" */ '@/modules/league/tier/view/add.vue');
const LeagueTierEdit = () => import(/* webpackChunkName: "league" */ '@/modules/league/tier/view/edit.vue');
const LeagueTierList = () => import(/* webpackChunkName: "league" */ '@/modules/league/tier/view/index.vue');

export const ROUTE_NAME_LEAGUE = {
    INDEX: 'LeagueList',
    ADD: 'LeagueAdd',
    EDIT: 'LeagueEdit',
    TIER: {
        INDEX: 'LeagueTierList',
        ADD: 'LeagueTierAdd',
        EDIT: 'LeagueTierEdit',
        REWARD: {
            INDEX: 'LeagueRewardList',
            ADD: 'LeagueRewardAdd',
            EDIT: 'LeagueRewardEdit'
        }
    }
} as const;

export default [
    {
        path: '/app/:appId/league/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_LEAGUE.INDEX,
                component: LeagueList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_LEAGUE.ADD,
                component: LeagueAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: ROUTE_NAME_LEAGUE.EDIT,
                component: LeagueEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':itemId/tier',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_LEAGUE.TIER.INDEX,
                        component: LeagueTierList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_LEAGUE.TIER.ADD,
                        component: LeagueTierAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':tier/edit',
                        name: ROUTE_NAME_LEAGUE.TIER.EDIT,
                        component: LeagueTierEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: ':itemId/tier/:tier/reward',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_LEAGUE.TIER.REWARD.INDEX,
                        component: LeagueRewardList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_LEAGUE.TIER.REWARD.ADD,
                        component: LeagueRewardAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':position',
                        name: ROUTE_NAME_LEAGUE.TIER.REWARD.EDIT,
                        component: LeagueRewardEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
